import {Component, OnInit, Injector} from '@angular/core';
import { SettingsService } from '../../../core/settings/settings.service';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { MenuService } from '../../../core/menu/menu.service';
import { menuIcons, menuSupervisor, menuCN, menuBackoffice } from '../../menu';
import {Md5} from 'ts-md5';

@Component({
    selector: 'app-login',
    standalone: false,
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})

export class LoginComponent implements OnInit {

  valForm: UntypedFormGroup;

  protected router: Router;

  errorMessage = '';
  errorFiltro = '';

  public operacao: string = 'manual';
  public dadosArmazenados: any = {};
  public checaFiltros: number = 0;

  hashAuth = '';

  constructor(
      injector: Injector,
      public settings: SettingsService,
      public menuService: MenuService,
      private http: HttpClient,
      fb: UntypedFormBuilder
  ) {

    this.valForm = fb.group({
        cpf: [null, Validators.required],
        password: [null, Validators.required],
        remember: [null]
    });

    this.router = injector.get(Router);

    this.errorMessage = '';

  }

  ngOnInit() {

    // console.log('>>>>>>>>>> Verificando LocalStorage...');
   if (localStorage.getItem('AUTH')) {

      this.operacao = 'auto';

      // console.log('>>>>> Usuario apto a login automatico.');
      this.dadosArmazenados = JSON.parse(localStorage.getItem('AUTH'));
      // this.hashAuth = this.dadosArmazenados.hashAuth;
      // console.log('>> cpf: ' + this.dadosArmazenados.cpf);
      // console.log('>> senha: ' + this.dadosArmazenados.senha);
      // console.log('>> url: ' + this.settings.urlretorno);
      this.login('');

    } else {
      // console.log('>>>>> Usuario não apto a login automatico.');
      this.operacao = 'manual';
      // console.log('>>>>> Habilitando login manual...');
    }

  }

  voltarLogin() {
    localStorage.clear();
    this.operacao = 'manual';
  }

  primeiroAcesso() {
    this.router.navigate(['/primeiro-acesso']);
  }

  submitForm($ev, value: any) {

    // console.log('>>>>>>>>>> iniciando login...');

    $ev.preventDefault();

    for (let c in this.valForm.controls) {
        this.valForm.controls[c].markAsTouched();
    }

    if (this.valForm.valid) {
      this.login(value);
    }
  }

 login(value: any) {

    let credenciais: any = {};
    let auth: any = {};

    credenciais.versao = '2023.08.10';

    if (this.operacao === 'manual') {

      credenciais.operacao = 'manual';
      credenciais.cpf = value.cpf;
      credenciais.senha = value.password;
      auth.hash = value.cpf + Md5.hashStr(value.password);

    } else if (this.operacao === 'auto') {

      credenciais.operacao = 'auto';
      credenciais.cpf = this.dadosArmazenados.cpf;
      credenciais.senha = this.dadosArmazenados.senha;
      auth.hash = this.dadosArmazenados.cpf + this.dadosArmazenados.senha;
    }

    const config = {
      headers: {
        'x-token': this.settings.configUso.X_TOKEN_API,
        hash_auth: this.hashAuth,
        auth: auth.hash
      }
    };

    const url = this.settings.configUso.urlApiPadrao + 'v2/hotsite/login';

    // console.log('>>>>> url:' + url);
    // console.log('>>>>> credenciais:' + JSON.stringify(credenciais));

    this.http.post(url, credenciais, config)
      .subscribe(data => {
          // console.log('>>>>> Result:' + JSON.stringify(data));

          if (data['status'] === 200) {

            // console.log('>>>>> login Ok...');
            // console.log('>>>>> idperfil:' + data['result'].idperfil);

            /********************************/
            /***** SE NÃO RETORNA DADOS *****/
            /********************************/

            if (!data['result']) {
              return this.errorMessage = data['message'];
            }

            /*************************/
            /***** DEFINE ACESSO *****/
            /*************************/

            if (
              data['result'].idperfil !== 1
              && data['result'].idperfil !== 2
              && data['result'].idperfil !== 3
              && data['result'].idperfil !== 7
              && data['result'].idperfil !== 8
              && data['result'].idperfil !== 11
            ) {
              this.operacao = 'manual';
              return this.errorMessage = 'Acesso Negado!';
            }

            this.settings.logado = true;
            this.settings.user = data['result'];

            /********************************/
            /***** DEFINE MANTER LOGADO *****/
            /********************************/

            if (value.remember || this.operacao === 'auto') {
              localStorage.setItem('AUTH', JSON.stringify(this.settings.user));
              // console.log('>>>>> localstorage AUTH: ' + JSON.stringify(localStorage.getItem('AUTH')));
            } else {
              localStorage.clear();
              this.errorMessage = '';
            }

            /***************************/
            /***** CARREGA FILTROS *****/
            /***************************/

            this.carregaFiltros();

          } else {
            this.voltarLogin();
            this.errorMessage = data['message'];
          }
        },
        (error: HttpErrorResponse) => {
          this.voltarLogin();
          this.errorMessage = error.message;
        });

  }

  async carregaFiltros() {

    this.operacao = 'setup';
    this.errorFiltro = '';
    this.checaFiltros = 0;

    // console.log('Carregando Filtros...');

    // this.finalizaLogin();

    await this.listaDDDs();
    await this.listaUFs();
    await this.listaRegionais();
    await this.listaCNs();
    // await this.listaVendedores();
    // await this.listaDistribuidores();
    await this.listaPerfis();
    await this.listaCiclos();
    await this.listaTags();
    /*
    this.listaRedesTipos();
    this.listaSegmentos();
    this.listaAgrupamentos();
    this.listaPlanos();
    this.listaLojas();
    this.listaKAs();
    this.listaRedes();
    */

  }

  finalizaLogin() {

    // if (this.checaFiltros < 8) {

    //   console.log('Filtros carregados: ' + this.checaFiltros + ' / 7');

    // } else {
    
      console.log('carregando filtros...');
      
      /***********************/
      /***** DEFINE MENU *****/
      /***********************/

      if (this.settings.user.idperfil === 1) {
        this.menuService.addMenu(menuIcons);
      }

      if (this.settings.user.idperfil === 7) {
        this.menuService.addMenu(menuCN);
      }

      if (this.settings.user.idperfil === 8) {
        this.menuService.addMenu(menuBackoffice);
      }

      if (this.settings.user.idperfil === 11) {
        this.menuService.addMenu(menuSupervisor);
      }

      /***************************/
      /***** DEFINE REDIRECT *****/
      /***************************/

      if (!this.settings.urlretorno || this.settings.urlretorno === '') {

        // console.log('>>>>> Vai pra HOME...');
        this.router.navigate(['/dashboard/vendas']);

      } else {
        // console.log('>>>>> Vai pra URL DE RETORNO...');
        this.router.navigate([this.settings.urlretorno]);
      }

    // }

  }

  async listaRegionais() {

    // console.log('listando Regionais...');

    const config = {
      headers: {
          'x-token': this.settings.configUso.X_TOKEN_API,
          'auth-token': this.settings.user.hash_auth
      },
      params: {
        cpf: this.settings.user.cpf,
        idperfil: this.settings.user.idperfil,
        idowner: this.settings.user.idowner
      }
    };

    const url = await this.settings.configUso.urlApiPadrao + 'v1/filtros/regionais';

    this.http.get(url, config)

      .subscribe(data => {
        if (data['status'] === 200) {

          this.settings.filtroRegionais = data['result'];
          this.checaFiltros ++;
          this.finalizaLogin();

        } else {

          this.errorFiltro = 'Erro ao carregar filtro de Regionais.';

        }
      });

  }

  async listaDDDs() {

    // console.log('listando DDDs...');

    const config = {
      headers: {
         'x-token': this.settings.configUso.X_TOKEN_API,
         'auth-token': this.settings.user.hash_auth
      },
      params: {
        
        cpf: this.settings.user.cpf,
        idperfil: this.settings.user.idperfil,
        idowner: this.settings.user.idowner
      }
    };

    const url = await this.settings.configUso.urlApiPadrao + 'v1/filtros/ddds';

    this.http.get(url, config)

        .subscribe(data => {
          if (data['status'] === 200) {

            this.settings.filtroDDDs = data['result'];
            this.checaFiltros ++;
            this.finalizaLogin();

          } else {

            this.errorFiltro = 'Erro ao carregar filtro de DDDs.';

          }
        });

  }

  async listaUFs() {

    // console.log('listando UFs...');

    const config = {
      headers: {
          'x-token': this.settings.configUso.X_TOKEN_API,
          'auth-token': this.settings.user.hash_auth
      },
      params: {
        
        cpf: this.settings.user.cpf,
        idperfil: this.settings.user.idperfil,
        idowner: this.settings.user.idowner
      }
    };

    const url = await this.settings.configUso.urlApiPadrao + 'v1/filtros/ufs';

    this.http.get(url, config)

      .subscribe(data => {
        if (data['status'] === 200) {

          this.settings.filtroUFs = data['result'];

          this.checaFiltros ++;
          this.finalizaLogin();

        } else {

          this.errorFiltro = 'Erro ao carregar filtro de UFs.';

        }
      });

  }

  async listaCNs() {

    // console.log('listando CNs...');

    const config = {
      headers: {
          'x-token': this.settings.configUso.X_TOKEN_API,
          'auth-token': this.settings.user.hash_auth
      },
      params: {
        
        cpf: this.settings.user.cpf,
        idperfil: this.settings.user.idperfil,
        idowner: this.settings.user.idowner
      }
    };

    const url = await  this.settings.configUso.urlApiPadrao + 'v1/filtros/cn';

    this.http.get(url, config)

      .subscribe(data => {
        if (data['status'] === 200) {

          this.settings.filtroCNs = data['result'] ? data['result'] : [];

          this.checaFiltros ++;
          this.finalizaLogin();

        } else {

          this.errorFiltro = 'Erro ao carregar filtro de CNs.';

        }

      });

  }

  // listaKAs() {

  //   // console.log('listando CNs...');

  //   const config = {
  //     params: {
  //       cpf: this.settings.user.cpf,
  //       idperfil: this.settings.user.idperfil,
  //       idowner: this.settings.user.idowner
  //     }
  //   };

  //   const url = this.settings.configUso.urlApiPadrao + 'v1/filtros/key';

  //   this.http.get(url, config)

  //       .subscribe(data => {
  //         if (data['status'] === 200) {

  //           this.settings.filtroKAs = data['result'];

  //           this.checaFiltros ++;
  //           this.finalizaLogin();

  //         } else {

  //           this.errorFiltro = 'Erro ao carregar filtro de Key Accounts.';

  //         }

  //       });

  // }

  async listaVendedores() {

    // console.log('listando Vendedores...');

    const config = {
      headers: {
          'x-token': this.settings.configUso.X_TOKEN_API,
          'auth-token': this.settings.user.hash_auth
      },
      params: {
        
        cpf: this.settings.user.cpf,
        idperfil: this.settings.user.idperfil,
        idowner: this.settings.user.idowner
      }
    };

    const url = await  this.settings.configUso.urlApiPadrao + 'v1/filtros/vendedores';

    this.http.get(url, config)

        .subscribe(data => {
          if (data['status'] === 200) {

            this.settings.filtroVendedores = data['result'];

            this.checaFiltros ++;
            this.finalizaLogin();

          } else {

            this.errorFiltro = 'Erro ao carregar filtro de Vendedores.';

          }

        });

  }

  async listaPerfis() {
    // console.log('listando Perfis...');

    const config = {
        headers: {
            'x-token': this.settings.configUso.X_TOKEN_API,
            'auth-token': this.settings.user.hash_auth
        },
        params: {
            
            cpf: this.settings.user.cpf
        }
    }

    const url = await this.settings.configUso.urlApiPadrao + 'v1/filtros/perfis';

    this.http.get(url, config)

      .subscribe(data => {
        if (data['status'] === 200) {

          this.settings.filtroPerfis = data['result'];

          this.checaFiltros ++;
          this.finalizaLogin();

        } else {

          this.errorFiltro = 'Erro ao carregar filtro de Redes.';

        }
      });
  }

  async listaCiclos() {

      const config = {
          headers: {
              'x-token': this.settings.configUso.X_TOKEN_API,
              'auth-token': this.settings.user.hash_auth
          },
          params: {
              
              cpf: this.settings.user.cpf
          }
      }

    const url = await  this.settings.configUso.urlApiPadrao + 'v1/filtros/ciclos';

    this.http
      .get(url, config)
      .subscribe(data => {
        if (data['status'] === 200) {

          this.settings.filtroCiclos = data['result'];

          this.checaFiltros ++;
          this.finalizaLogin();

        } else {

          this.errorFiltro = 'Erro ao carregar filtro de Ciclos.';

        }
      });
  }

    async listaTags() {
        const config = {
            headers: {
                'x-token': this.settings.configUso.X_TOKEN_API,
                'auth-token': this.settings.user.hash_auth
            },
            params: {
                
                cpf: this.settings.user.cpf
            }
        }

        const url = await  this.settings.configUso.urlApiPadrao + 'v1/adm/tags/lista';

        this.http
            .get(url, config)
            .subscribe(data => {
                if (data['status'] === 200) {

                    this.settings.filtroTags = data['result'];

                    this.checaFiltros ++;
                    this.finalizaLogin();

                } else {

                    this.errorFiltro = 'Erro ao carregar filtro de Ciclos.';

                }
            });
    }

}
